
import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import ChooseGoodsCard from "@/views/orderManage/template/ChooseGoodsCard.vue";
import {SelectGoodsOptionsDto} from "@/api/commonConfig";
import {LevelListDto} from "@/api/customerManage";

const BALL_LEN = 10
const innerClsHook = 'inner-hook'

function createBalls() {
    let balls = []
    for (let i = 0; i < BALL_LEN; i++) {
        balls.push({show: false})
    }
    return balls
}

@Component({
    name: 'BuyCarPop',
    components: {ChooseGoodsCard}
})
export default class BuyCarPop extends Vue {
    @Prop({default: () => []}) buyCarList: SelectGoodsOptionsDto[]
    @Prop({default: ''}) customerId?: string

    showDialog = false
    value = 2

    // 动画小球
    balls = createBalls()
    dropBalls: any[] = []
    selectList: SelectGoodsOptionsDto[] = []

    @Watch('buyCarList', {deep: true, immediate: true})
    changeBuyCarList(val: SelectGoodsOptionsDto[]) {
        this.selectList = val
    }

    created() {
        this.selectList = this.buyCarList
        console.log('this.buyCarList',this.buyCarList)
    }

    // buyCarList: SelectGoodsOptionsDto[] = []

    show(params: { data: SelectGoodsOptionsDto[] }) {
        this.showDialog = true
        // if (params.data && params.data.length > 0) {
        //     this.buyCarList = JSON.parse(JSON.stringify(params.data))
        // }
    }

    drop(el) {
        for (let i = 0; i < this.balls.length; i++) {
            const ball = this.balls[i]
            if (!ball.show) {
                ball.show = true
                ball.el = el
                this.dropBalls.push(ball)
                return
            }
        }
    }

    beforeDrop(el) {
        const ball = this.dropBalls[this.dropBalls.length - 1]
        const rect = ball.el.getBoundingClientRect()
        const x = rect.left - 32
        const y = -(window.innerHeight - rect.top - 22)
        el.style.display = ''
        el.style.transform = el.style.webkitTransform = `translate3d(0,${y}px,0)`
        const inner = el.getElementsByClassName(innerClsHook)[0]
        inner.style.transform = inner.style.webkitTransform = `translate3d(${x}px,0,0)`
    }

    dropping(el, done) {
        // @ts-ignore
        this._reflow = document.body.offsetHeight
        el.style.transform = el.style.webkitTransform = `translate3d(0,0,0)`
        const inner = el.getElementsByClassName(innerClsHook)[0]
        inner.style.transform = inner.style.webkitTransform = `translate3d(0,0,0)`
        el.addEventListener('transitionend', done)
    }

    afterDrop(el) {
        const ball = this.dropBalls.shift()
        if (ball) {
            ball.show = false
            el.style.display = 'none'
        }
    }

    beforeClose({position, instance}) {
        switch (position) {
            case 'cell':
                debugger
                break;
            case 'outside':
                instance.close();
                break;
        }
    }

    minusHandle(list,index: number) {
      // this.$dialog.confirm({
      //   title: '温馨提示',
      //   message: '是否确认删除商品？',
      // })
      //   .then(() => {
      //     this.delData(index)
      //   })
      //   .catch(() => {
      //   });
      console.log(list)
      if(list.saleAmount == list.minimum) {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '是否确认删除商品？',
        }).then(() => {
              this.delData(index)
            })
      }
    }

    delData(index: number) {
        this.selectList.splice(index, 1)
        if (this.selectList.length === 0) {
            this.showDialog = false
        }
    }
}
